import * as React from 'react'

import Presta from './detail/Presta'
import Manif from './detail/Manif'
import Space from './detail/Space'

interface Props {
  societeId?: string
  manifestationId?: string
  spaceId?: string
}

const ControleDetailScreen = ({ manifestationId, societeId, spaceId }: Props) => {
  if (manifestationId) {
    return <Manif manifestationId={manifestationId} />
  }

  if (societeId) {
    return <Presta societeId={societeId} />
  }

  if (spaceId) {
    return <Space espaceId={spaceId} />
  }

  return null
}

export default ControleDetailScreen
